import { DropDownGroupType, FieldSourceType, FilterControlType, IReportsComponents } from "./reportfilter";

export const ReportsControls: Array<IReportsComponents> =
  [
    /*AskaQuestionReport*/
    {
      ReportName: 'QuestionsReport',
      ServiceParentName: 'AskaQuestionReport',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.MessageCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: '_MessageCategoryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "QuestionTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Title',
            placeholderText: 'Enter Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },

    /*DiscussionReports*/
    {
      ReportName: 'DiscussionActivitySummaryByTopicReport',
      ServiceParentName: 'DiscussionReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.Forum,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "ForumIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Forum(s)',
            placeholderText: 'Forum(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'ForumName',
            valueField: 'ForumID'
          },
          {
            fieldSourceType: FieldSourceType.Topic,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TopicIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Topic(s)',
            placeholderText: 'Topic(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'TopicName',
            valueField: 'TopicID'
          }
        ]
    },
    {
      ReportName: 'DiscussionPostsByTopicReport',
      ServiceParentName: 'DiscussionReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.Forum,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "ForumIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Forum(s)',
            placeholderText: 'Forum(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'ForumName',
            valueField: 'ForumID'
          },
          {
            fieldSourceType: FieldSourceType.Topic,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TopicIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Topic(s)',
            placeholderText: 'Topic(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'TopicName',
            valueField: 'TopicID'
          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          }
        ]
    },
    {
      ReportName: 'DiscussionPostsByUserReport',
      ServiceParentName: 'DiscussionReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          }
        ]
    },
    {
      ReportName: 'PollResultsReport',
      ServiceParentName: 'DiscussionReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.Poll,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "PollIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Poll(s)',
            placeholderText: 'Poll(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'TopicName',
            valueField: 'TopicID'
          }
        ]
    },

    /*DocumentReports*/
    {
      ReportName: 'DocumentDownloadTrackingReport',
      ServiceParentName: 'DocumentReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,11],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3,11],
            controlName: "DocumentTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Title',
            placeholderText: 'Enter Document Title',
            multipleSelect: false,
            textAsValueField: false,
            textField: undefined,
            valueField: undefined
          },
          {
            fieldSourceType: FieldSourceType.DocumentStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "DocumentStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Status',
            placeholderText: 'Document Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,11],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Documents,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          }
        ]
    },
    {
      ReportName: 'DocumentManagementReport',
      ServiceParentName: 'DocumentReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Documents,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3,11],
            controlName: "DocumentTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Title',
            placeholderText: 'Enter Document Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },
    {
      ReportName: 'DocumentPermissionReport',
      ServiceParentName: 'DocumentReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Documents,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3,11],
            controlName: "DocumentTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Title',
            placeholderText: 'Enter Document Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },

    /*EnterpriseReports*/
    {
      ReportName: 'EnterpriseTrainingTrackingReport',
      ServiceParentName: 'EnterpriseReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.TrainingActiveStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TrainingActiveStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Status',
            placeholderText: 'Training Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'EnterpriseUserStudiesReport',
      ServiceParentName: 'EnterpriseReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SponsorEnterpriseUsers,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          }
        ]
    },
    {
      ReportName: 'EnterpriseSafetyReportsCompletionSummaryReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SafetyReportEnabledStudy,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "StudyId",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Study',
            placeholderText: 'Study',
            multipleSelect: false,
            textAsValueField: false,
            textField: 'PortalName',
            valueField: 'PortalID',
            isDynamic: false,
            isHidden:false
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteCountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site country(s)',
            placeholderText: 'Site country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID',
            isDynamic: false,
            isHidden: true

          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: [],
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID',
            isDynamic: false,
            isHidden: true

          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false,
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CompletionStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site Signature Status',
            placeholderText: 'Site Signature Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: true
          }
        ]
    },
    {
      ReportName: 'EnterpriseSafetyReportsCompletionDetailReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SafetyReportEnabledStudy,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "StudyId",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Study',
            placeholderText: 'Study',
            multipleSelect: false,
            textAsValueField: false,
            textField: 'PortalName',
            valueField: 'PortalID',
            isDynamic: false,
            isHidden: false
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteCountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site country(s)',
            placeholderText: 'Site country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID',
            isDynamic: false,
            isHidden: true

          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: [],
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID',
            isDynamic: false,
            isHidden: true

          },          
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CompletionStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site Signature Status',
            placeholderText: 'Site Signature Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Reports Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false,
            isHidden: true,
            isDynamic:false
          }
        ]
    },
    {
      ReportName: 'EnterpriseSafetyReportsDistributionReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SafetyReportEnabledStudy,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "StudyId",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Study',
            placeholderText: 'Study',
            multipleSelect: false,
            textAsValueField: false,
            textField: 'PortalName',
            valueField: 'PortalID',
            isDynamic: false,
            isHidden: false
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: true
          },          
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Reports Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false,
            isHidden: true,
            isDynamic: false
          }
        ]
    },
    {
      ReportName: 'EnterpriseSafetyReportsManagementReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SafetyReportEnabledStudy,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "StudyId",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Study',
            placeholderText: 'Study',
            multipleSelect: false,
            textAsValueField: false,
            textField: 'PortalName',
            valueField: 'PortalID',
            isDynamic: false,
            isHidden: false
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Reports Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false,
            isHidden: true,
            isDynamic: false
          }
        ]
    },
    {
      ReportName: 'EnterpriseSiteReport',
      ServiceParentName: 'UserReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.Portal,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "StudyId",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Study',
            placeholderText: 'Study',
            multipleSelect: false,
            textAsValueField: false,
            textField: 'PortalName',
            valueField: 'PortalID',
            isDynamic: false,
            isHidden: false
          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SiteType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site Type(s)',
            placeholderText: 'Site Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.PrimaryCRA,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CRAUserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'CRA(s)',
            placeholderText: 'CRA(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID',
            isDynamic: false,
            isHidden: true
          }
        ]
    },
    {
      ReportName: 'EnterpriseUserReport',
      ServiceParentName: 'UserReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.Portal,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "StudyId",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Study',
            placeholderText: 'Study',
            multipleSelect: false,
            textAsValueField: false,
            textField: 'PortalName',
            valueField: 'PortalID',
            isDynamic: false,
            isHidden: false
          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID',
            isDynamic: false,
            isHidden: true
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID',
            isDynamic: false,
            isHidden: true
          }
        ]
    },

    /*FAQReports*/
    {
      ReportName: 'FAQManagementReport',
      ServiceParentName: 'FAQReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.FAQSection,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "FaqSection",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Topic(s)',
            placeholderText: 'Topic(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'AssetName',
            valueField: 'AssetName'
          },
          {
            fieldSourceType: FieldSourceType.FAQCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Subtopic(s)',
            placeholderText: 'Subtopic(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'FAQTypeName',
            valueField: '_FAQTypeID',
            isDependentControl: true,
            dependentControlName: 'FaqSection',
            dependentFilterId: "_AssetID",
          }
        ]
    },

    /*MessageReports*/
    {
      ReportName: 'MessageAcknowledgementReport',
      ServiceParentName: 'MessageReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "MessageTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Message Title',
            placeholderText: 'Enter Message Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Alerts,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AssetCategoryID'
          }
        ]
    },
    {
      ReportName: 'MessageManagementReport',
      ServiceParentName: 'MessageReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Alerts,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AssetCategoryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "MessageReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Title',
            placeholderText: 'Enter Title',
            multipleSelect: false,
            textAsValueField: false
          },
        ]
    },

    /*SafetyReports*/
    {
      ReportName: 'ProgramLevelSafetyReportsAssignmentReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AssetCategoryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Title',
            placeholderText: 'Enter Title',
            multipleSelect: false,
            textAsValueField: false
          },
        ]
    },
    {
      ReportName: 'SafetyReportsCompletionDetailReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteCountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site country(s)',
            placeholderText: 'Site country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID',
            isDynamic: false

          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID',
            isDynamic: false
            
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID',
            isDynamic: false
          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CompletionStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site Signature Status',
            placeholderText: 'Site Signature Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Reports Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false,
            isDynamic: false
          }
        ]
    },
    {
      ReportName: 'SafetyReportsCompletionSummaryReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteCountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site country(s)',
            placeholderText: 'Site country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'

          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID'
          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'            
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CompletionStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site Signature Status',
            placeholderText: 'Site Signature Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'SafetyReportsManagementReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID'
          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic:false
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Reports Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },

    {
      ReportName: 'SafetyReportsDistributionReport',
      ServiceParentName: 'SafetyReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SafetyReportType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SusarTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Report Type',
            placeholderText: 'Safety Report Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Name',
            valueField: 'SusarTypeID'
          },
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "SafetyReportTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Safety Reports Title',
            placeholderText: 'Enter Safety Reports Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },

    /*TeamDocumentReports*/
    {
      ReportName: 'TeamDocumentDownloadTrackingReport',
      ServiceParentName: 'TeamDocumentReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "DocumentTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Title',
            placeholderText: 'Enter Document Title',
            multipleSelect: false,
            textAsValueField: false,
            textField: undefined,
            valueField: undefined
          },
          {
            fieldSourceType: FieldSourceType.DocumentStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "DocumentStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Status',
            placeholderText: 'Document Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Teamdocument,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          }
        ]
    },
    {
      ReportName: 'TeamDocumentManagementReport',
      ServiceParentName: 'TeamDocumentReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Teamdocument,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "DocumentTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Title',
            placeholderText: 'Enter Document Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },
    {
      ReportName: 'TeamDocumentPermissionReport',
      ServiceParentName: 'TeamDocumentReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Teamdocument,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "DocumentTitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Title',
            placeholderText: 'Enter Document Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },

    /*TrainingReports*/
    {
      ReportName: 'TrainingModuleCompletionReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.CheckBox,
            platformAvailable: [1, 3],
            controlName: "IncludeRetiredTrainings",
            dataSource: [{ Text: 'Include retired', Value: true, Visibled: true }],
            dropdownGroupType: undefined,
            labelText: '',
            placeholderText: '',
            multipleSelect: false,
            textAsValueField: false,
            textField: undefined,
            valueField: undefined,
            toolTipText: 'Checking this box will include all retired trainings.'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.CheckBox,
            platformAvailable: [1, 3],
            controlName: "IncludeUnassignedTrainings",
            dataSource: [{ Text: 'Include unassigned', Value: true, Visibled: true }],
            dropdownGroupType: undefined,
            labelText: '',
            placeholderText: '',
            multipleSelect: false,
            textAsValueField: false,
            textField: undefined,
            valueField: undefined,
            toolTipText: 'Checking this box will include all active trainings that are no longer assigned to the user.'
          },
        ]
    },
    {
      ReportName: 'TrainingModuleTrackingReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.TrainingActiveStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TrainingActiveStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Status',
            placeholderText: 'Training Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'TrainingModuleTrackingReportOLD',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          }
        ]
    },
    {
      ReportName: 'TrainingStatusOverrideReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.TrainingActiveStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TrainingActiveStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Status',
            placeholderText: 'Training Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'TrainingQuestionsResponseReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.TrainingActiveStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TrainingActiveStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Status',
            placeholderText: 'Training Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'UserTrainingAssignmentReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.DelegationAction,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "ActionIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Action(s)',
            placeholderText: 'Action(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "DelegatorIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Delegator(s)',
            placeholderText: 'Delegator(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          }
        ]
    },


    /*UserReports*/
    {
      ReportName: 'SiteReport',
      ServiceParentName: 'UserReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,11],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteType,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,11],
            controlName: "SiteTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site Type(s)',
            placeholderText: 'Site Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.PrimaryCRA,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "CRAUserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'CRA(s)',
            placeholderText: 'CRA(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          }
        ]
    },
    {
      ReportName: 'UserReport',
      ServiceParentName: 'UserReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,11],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3,11],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          }
        ]
    },
    {
      ReportName: 'UserReport-Archived',
      ServiceParentName: 'UserReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          }
        ]
    },

    /*MetricesUserReports*/

    {
      ReportName: 'UserStatus',
      ServiceParentName: 'MetricsReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          }
        ]
    },
    {
      ReportName: 'Training',
      ServiceParentName: 'MetricsReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.MetricsUserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.ViewRequirement,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "ViewRequirement",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'View Requirement',
            placeholderText: 'View Requirement',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SignatureRequirement,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "SignatureRequirement",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Signature Requirement',
            placeholderText: 'Signature Requirement',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Training,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AssetCategoryID'
          },
          {
            fieldSourceType: FieldSourceType.Title,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Title",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Training,
            labelText: 'Title(s)',
            placeholderText: 'Title(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'AssetName',
            valueField: 'AssetID'
          },
          {
            fieldSourceType: FieldSourceType.TrainingAssignmentStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "AssetStatusIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Assignment Status',
            placeholderText: 'Training Assignment Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'Messages',
      ServiceParentName: 'MetricsReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.MetricsUserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.ViewRequirement,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "ViewRequirement",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'View Requirement',
            placeholderText: 'View Requirement',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SignatureRequirement,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "SignatureRequirement",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Signature Requirement',
            placeholderText: 'Signature Requirement',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Alerts,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AssetCategoryID'
          },
          {
            fieldSourceType: FieldSourceType.Title,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Title",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Alerts,
            labelText: 'Title(s)',
            placeholderText: 'Title(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'AssetName',
            valueField: 'AssetID'
          },
          {
            fieldSourceType: FieldSourceType.AssignmentStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "AssetStatusIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Message Assignment Status',
            placeholderText: 'Message Assignment Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'Documents',
      ServiceParentName: 'MetricsReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.MetricsUserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.ViewRequirement,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "ViewRequirement",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'View Requirement',
            placeholderText: 'View Requirement',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SignatureRequirement,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "SignatureRequirement",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Signature Requirement',
            placeholderText: 'Signature Requirement',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Documents,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AssetCategoryID'
          },
          {
            fieldSourceType: FieldSourceType.Title,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Title",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Documents,
            labelText: 'Title(s)',
            placeholderText: 'Title(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'AssetName',
            valueField: 'AssetID'
          },
          {
            fieldSourceType: FieldSourceType.AssignmentStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "AssetStatusIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Assignment Status',
            placeholderText: 'Document Assignment Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'SafetyReports',
      ServiceParentName: 'MetricsReports',
      Controls:
        [
          {
          fieldSourceType: FieldSourceType.SafetyReportType,
          filterControlType: FilterControlType.DropDown,
          platformAvailable: [1,3],
          controlName: "SusarTypeIds",
          dataSource: undefined,
          dropdownGroupType: undefined,
          labelText: 'Safety Report Type',
          placeholderText: 'Safety Report Type(s)',
          multipleSelect: true,
          textAsValueField: false,
          textField: 'Name',
          valueField: 'SusarTypeID'
          },
          {
            fieldSourceType: FieldSourceType.SafetyReportTitle,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Title",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            labelText: 'Safety Reports Title(s)',
            placeholderText: 'Safety Reports Title(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'AssetName',
            valueField: 'AssetID',
            isDynamic: false
          }
        ]
    },

    /* Safety Report Grid*/
    {
      ReportName: 'SafetyReportsGrid',
      ServiceParentName: 'SafetyReportsGrid',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SusarTitle,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Title",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Title(s)',
            placeholderText: 'Title(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Country_of_Origin,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CountryofOrigin",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
           //labelText: 'Country of Origin(s)',
            placeholderText: 'Country of Origin(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Study_of_Origin,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "StudyofOrigin",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Study of Origin(s)',
            placeholderText: 'Study of Origin(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Protocol_of_Origin,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "ProtocolofOrigin",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Protocol of Origin(s)',
            placeholderText: 'Protocol of Origin(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Compound,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Compound",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Compound(s)',
            placeholderText: 'Compound(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Initial_Follow_up,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "InitialFollowup",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Initial/Follow-up',
            placeholderText: 'Initial/Follow-up',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.AE_Term,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "AETerm",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
           // labelText: 'AE Term(s)',
            placeholderText: 'AE Term(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Visit_Type,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "VisitType",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Visit Type(s)',
            placeholderText: 'Visit Type(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Global_Case_ID,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "GlobalCaseID",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Global Case ID(s)',
            placeholderText: 'Global Case ID(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Type_Abbreviation,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Abbreviation",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            //labelText: 'Date Sent',
            placeholderText: 'Abbreviation(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Date_Sent,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 3],
            controlName: "DateSent",
            dataSource: undefined,
            dropdownGroupType: undefined,
            //labelText: 'Date Sent',
            placeholderText: 'Select date sent',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.Event_date,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 3],
            controlName: "Eventdate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            //labelText: 'Eventdate',
            placeholderText: 'Select event date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.Death_or_Life_Threatening,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "DeathorLifeThreatening",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Susar,
            placeholderText: 'Death or Life Threatening',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.Creation_Date,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 3],
            controlName: "CreationDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            placeholderText: 'Select creation date',
            multipleSelect: false,
            textAsValueField: false
          }
          
        ]
    },
    {
      ReportName: 'AlchemerAliasPWListReport',
      ServiceParentName: 'StartupReports',
      Controls:
        []
    },
    {
      ReportName: 'SiteDeclinedInviteReport',
      ServiceParentName: 'StartupReports',
      Controls:
        [
          {
          fieldSourceType: FieldSourceType.DeclinedSiteName,
          filterControlType: FilterControlType.DropDown,
          platformAvailable: [1],
          controlName: "SiteIds",
          dataSource: undefined,
          dropdownGroupType: undefined,
          labelText: 'Site(s)',
          placeholderText: 'Site(s)',
          multipleSelect: true,
          textAsValueField: false,
          textField: 'SiteName',
          valueField: 'SiteID'
        },
        {
          fieldSourceType: FieldSourceType.Country,
          filterControlType: FilterControlType.DropDown,
          platformAvailable: [1],
          controlName: "CountryIds",
          dataSource: undefined,
          dropdownGroupType: undefined,
          labelText: 'Country(s)',
          placeholderText: 'Country(s)',
          multipleSelect: true,
          textAsValueField: false,
          textField: 'CountryName',
          valueField: 'CountryID'
        },
      ]
    },

    {
      ReportName: 'TrainingManagementReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.PortalLevel,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "Level",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Level(s)',
            placeholderText: 'Level(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
            isDynamic: false,
            isHidden: false
          },
          {
            fieldSourceType: FieldSourceType.AssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Training,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AssetCategoryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.TrainingSource,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "SourceIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Training,
            labelText: 'Upload Source(s)',
            placeholderText: 'Upload Source(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value',
          },

        ]
    },
    {
      ReportName: 'TrainingRequirementsOverrideReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.OverrideAssignmentTypes,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,3],
            controlName: "OverrideAssignmentTypeIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Override(s)',
            placeholderText: 'Override(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User Status',
            placeholderText: 'User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.TrainingActiveStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TrainingActiveStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Status',
            placeholderText: 'Training Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'DelegatedTrainingReport',
      ServiceParentName: 'TrainingReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'From Role(s)',
            placeholderText: 'From Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.UserStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'From User Status',
            placeholderText: 'From User Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'From User(s)',
            placeholderText: 'From User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: undefined,
            filterControlType: FilterControlType.TextBox,
            platformAvailable: [1, 3],
            controlName: "TitleSearchText",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Title',
            placeholderText: 'Enter Training Title',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.TrainingActiveStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 3],
            controlName: "TrainingActiveStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Training Status',
            placeholderText: 'Training Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          }
        ]
    },
    {
      ReportName: 'DocumentViewsReport',
      ServiceParentName: 'StudyStatReport',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.FromDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 11],
            controlName: "FromDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Starting View Date',
            placeholderText: 'Select date',
            multipleSelect: false,
            textAsValueField: false
          },
           {
            fieldSourceType: FieldSourceType.ToDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 11],
            controlName: "ToDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Ending View Date',
            placeholderText: 'Select date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.StudyStatAssetCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,11],
            controlName: "CategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Documents,
            labelText: 'Category(s)',
            placeholderText: 'Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          },
          {
            fieldSourceType: FieldSourceType.StudyStatAssetSubCategory,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,11],
            controlName: "SubCategoryIds",
            dataSource: undefined,
            dropdownGroupType: DropDownGroupType.Documents,
            labelText: 'Sub Category(s)',
            placeholderText: 'Sub Category(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'CategoryName',
            valueField: 'CategoryName'
          },
           {
            fieldSourceType: FieldSourceType.DocumentStatus,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 11],
            controlName: "DocumentStatus",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Document Status',
            placeholderText: 'Document Status',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'Text',
            valueField: 'Value'
          },
          
          
        ]
    },
    {
      ReportName: 'RAIQuestionsResponsesReport',
      ServiceParentName: 'RASPberryAIReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.FromDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 11, 12],
            controlName: "FromDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Start Date',
            placeholderText: 'Start Date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.ToDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 11, 12],
            controlName: "ToDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'End Date',
            placeholderText: 'End Date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.User,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 11, 12],
            controlName: "UserIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'User(s)',
            placeholderText: 'User(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'UserName',
            valueField: 'UserID'
          },
          {
            fieldSourceType: FieldSourceType.StatisfactoryResponse,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 11, 12],
            controlName: "StatisfactoryResponseIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Statisfactory Response(s)',
            placeholderText: 'Statisfactory Response(s)',
            multipleSelect: true,
            textAsValueField: true,
            textField: 'Text',
            valueField: 'Value'
          },
           {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 12],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,12],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          {
            fieldSourceType: FieldSourceType.AIQuestionCategoryName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 12],
            controlName: "QuestionCategoryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Question Category(s)',
            placeholderText: 'Question Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AIQuestionCategoryID'
          }
        ]
    },
    {
      ReportName: 'RAIDocumentViewsReport',
      ServiceParentName: 'RASPberryAIReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.FromDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 11, 12],
            controlName: "FromDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Start Date',
            placeholderText: 'Start Date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.ToDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 11, 12],
            controlName: "ToDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'End Date',
            placeholderText: 'End Date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.SiteRole,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 11, 12],
            controlName: "RoleIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Role(s)',
            placeholderText: 'Role(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'RoleName',
            valueField: 'RoleID'
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 11, 12],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
        ]
    },
    {
      ReportName: 'RAIRefactoredQuestionReport',
      ServiceParentName: 'RASPberryAIReports',
      Controls:
        [
          {
            fieldSourceType: FieldSourceType.FromDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 12],
            controlName: "FromDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Start Date',
            placeholderText: 'Start Date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.ToDate,
            filterControlType: FilterControlType.Date,
            platformAvailable: [1, 12],
            controlName: "ToDate",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'End Date',
            placeholderText: 'End Date',
            multipleSelect: false,
            textAsValueField: false
          },
          {
            fieldSourceType: FieldSourceType.Country,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 12],
            controlName: "CountryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Country(s)',
            placeholderText: 'Country(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CountryName',
            valueField: 'CountryID'
          },
          {
            fieldSourceType: FieldSourceType.SiteName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1,12],
            controlName: "SiteIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Site(s)',
            placeholderText: 'Site(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'SiteName',
            valueField: 'SiteID'
          },
          
           {
            fieldSourceType: FieldSourceType.AIQuestionCategoryName,
            filterControlType: FilterControlType.DropDown,
            platformAvailable: [1, 12],
            controlName: "QuestionCategoryIds",
            dataSource: undefined,
            dropdownGroupType: undefined,
            labelText: 'Question Category(s)',
            placeholderText: 'Question Category(s)',
            multipleSelect: true,
            textAsValueField: false,
            textField: 'CategoryName',
            valueField: 'AIQuestionCategoryID'
          }
        ]
    },

  ];
